<template>
  <div class="main" ref="activity_scroll" @scroll="activityScroll">
    <div class="banner">
        <epp-banner :showLogo="false" :type="4"></epp-banner>
    </div>
    <div class="p-m-detail" v-show="introLength > 0">
        <div class="p-r-content">
            <div class="p-r-info" :class="clickMore?'':'van-multi-ellipsis--l2'" v-html="detail"></div>
            <button class="bottom-btn-more" @click="moreContent" v-show="introLength >= 50">{{clickMore?'收起':'更多'}}</button>
        </div>
    </div>
    <div class="content" >
        <!-- pdf -->
        <h3 class="h3-title"><span>资料下载</span></h3>
        <product-shopping :productMaterial="productMaterial"></product-shopping>
        <!-- 视频 -->
        <h3 class="h3-title"><span>相关视频</span></h3>
        <new-pro-video :productVideo="productVideo" @videoChange="videoChange"></new-pro-video>
    </div>
    <footerLine></footerLine>
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import eppBanner from '@/components/eppBanner'
import { getProBindList,getMainDesc } from '@/api/centrifuge'
import productShopping from '@/components/product-shopping'
import newProVideo from '@/components/new-pro-video.vue'
import videoPlay from '@/components/videoPlay'
import footerLine from '@/components/footerLine'
export default {
    components: {
        eppBanner,
        productShopping,
        newProVideo,
        videoPlay,
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            last_page: 1,
            productMaterial: [], // pdf
            productVideo: [],
            introLength: 0,
            clickMore: false,
            detail: ''
        }
    },
    created() {
        this.getProList()
        this.getDesc()
    },
    methods: {
        getDesc() {
            getMainDesc({module:7}).then(res => {
                this.detail = res.data.desc
                this.introLength = res.data.desc.length
            })
        },
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            // console.log('父组件的',item);
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
        getProList() {
            let para = {
                module: '7',
                type: '1',
                page: this.page,
                cid: 0
            }
            let para1 = {
                module: '7',
                type: '2',
                page: this.page,
                cid: 0
            }
            
            getProBindList(para1).then(res => {
                // this.$toast.clear()
                if (this.productVideo.length == 0) {
                    this.productMaterial.push(...res.data.data)
                }
                this.last_page = res.data.last_page
                if(res.data.data.length <= 10) {
                    if (this.productVideo.length == 0) {
                        this.page = 1
                        para.page = this.page
                    }
                    
                    getProBindList(para).then(res => {
                        this.productVideo.push(...res.data.data)
                        this.last_page = res.data.last_page
                        console.log('绑定列表',res.data.last_page);
                    })
                }
            })
        },
        moreContent () {
            this.clickMore = !this.clickMore
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main {
    height: 100vh;
    overflow: auto;
}
.banner {
    margin-top: rem(12);
}
.content {
    margin-top: rem(20);
    
}
.p-m-detail {
    overflow: hidden;
    padding: rem(20);
    box-sizing: border-box;
    .p-r-content {
        background: #dee5ed;
        padding: rem(10) rem(20) rem(20);
        border-radius: 2px;
        .p-r-info{
            color: #333333;
            font-size: 12px;
            line-height: rem(20);
            word-break: break-word;
        }
        .van-multi-ellipsis--l2{
            transition: all .2s;
        }
        .bottom-btn-more{
            width: rem(72);
            height: rem(28);
            display: block;
            margin: 0 auto;
            margin-top: rem(20);
            border: 1px solid #2c2c2c;
            font-size: 13px;
            background: none;
            color: #2c2c2c;
            border-radius: 2px;
        }
    }
}
</style>